import { render, staticRenderFns } from "./AutoFormSection.vue?vue&type=template&id=64886cd4"
import script from "./AutoFormSection.vue?vue&type=script&lang=js"
export * from "./AutoFormSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports